import React, { Component, PropTypes } from 'react';
import Message from '../message/Message';
import AddToBody from '../helpers/AddToBody';

export default class ConfirmDialog extends Component {
    onButtonClick = action => {
        if (typeof action === 'function') action();
        this.props.closeFn();
    };

    render() {
        const {
            title,
            body,
            onPrimaryAction,
            onSecondaryAction,
            primaryButtonTitle = 'Yes',
            secondaryButtonTitle = 'No',
            hidePrimaryButton = false,
            hideSecondaryButton = false
        } = this.props;
        const onButtonClick = this.onButtonClick;

        return (
            <AddToBody>
                <div className="spark-modal active">
                    <div className="spark-modal__content col-xs-12 col-sm-10" style={{ padding: '2rem' }}>
                        <div className="row">
                            <div className="col-xs-12">
                                <Message
                                    heading={title}
                                    body={body}
                                    type="error"
                                    noBorder
                                    messagePanelClassName="spark-pad-0"
                                    size="xl"
                                    sizeClassName="spark-message--xl"
                                />
                            </div>
                            <div className="col-xs-12">
                                <nav className="spark-btn-group">
                                    {hideSecondaryButton ? null : (
                                        <button
                                            className="spark-btn spark-btn--md spark-btn--secondary spark-btn-group-secondary"
                                            onClick={function() {
                                                onButtonClick(onSecondaryAction);
                                            }}
                                        >
                                            {secondaryButtonTitle}
                                        </button>
                                    )}
                                    {hidePrimaryButton ? null : (
                                        <button
                                            className="spark-btn spark-btn--md spark-btn-group-primary"
                                            onClick={function() {
                                                onButtonClick(onPrimaryAction);
                                            }}
                                        >
                                            {primaryButtonTitle}
                                        </button>
                                    )}
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </AddToBody>
        );
    }
}

ConfirmDialog.propTypes = {
    body: PropTypes.string.isRequired,
    closeFn: PropTypes.func.isRequired,
    onPrimaryAction: PropTypes.func,
    onSecondaryAction: PropTypes.func,
    title: PropTypes.string,
    primaryButtonTitle: PropTypes.string,
    secondaryButtonTitle: PropTypes.string,
    hideSecondaryButton: PropTypes.bool,
    hidePrimaryButton: PropTypes.bool
};
ConfirmDialog.defaultProps = {
    closeFn: function() {},
    title: 'Confirm'
};



// WEBPACK FOOTER //
// ./src/components/modals/ConfirmDialog.js